import React from 'react';
import {buscarServicoDeBoleto} from '../../view/gru/actions/FormBuilderGRUActions'
import {CheckboxField, RadioButtonGroup, View, SelectField, CardSimples} from 'react-template'
import '../../assets/css/components/formbuilder/formGRUPreferences.css'

class FormGRUPreferences extends View { 

    radioOptions = [{value:"CPF",text:"CPF"},{value:"CNPJ",text:"CNPJ"}]

    constructor(props){
        super(props);
        this.setServicoBoleto = this.setServicoBoleto.bind(this);
        this.setStatus = this.setStatus.bind(this);
        this.mudaIdentificadorGRU = this.mudaIdentificadorGRU.bind(this);

        this.state = {
            servicoBoleto: [],
            optionServicoBoleto: []
        };
    }

    componentWillMount(){
        this.getServicosBoleto();
    }

    getServicosBoleto(){
        buscarServicoDeBoleto(res => {
            let optionServicoBoleto = []
            const servicoBoleto = res.data
            servicoBoleto.forEach( servico => {
                optionServicoBoleto.push({ key: servico.id, value: servico.id + "", text: servico.descricao })
            })

            if(optionServicoBoleto.length === 0){
                const mensagem = "Nenhum receita foi cadastrado."
                const corMensagem = "flat-blue"
                optionServicoBoleto = {mensagem, corMensagem}
                this.notifyInfo("Sem receita", mensagem)
            }

            this.setState({ ...this.state, servicoBoleto, optionServicoBoleto })
        },
        error => {
            const mensagem = 'Erro ao tentar recuperar receitas. Tente novamente mais tarde.'
            const corMensagem = ""
            let optionServicoBoleto = {mensagem, corMensagem}
            this.setState({ ...this.state, optionServicoBoleto })
            this.notifyError("Erro no serviço de receita", mensagem)
        })
    }

    setServicoBoleto(e, data){
        this.props.actions.updateServicoBoleto(data.value + "");
    }

    setStatus(e, data){
        this.props.actions.updateStatusDisponibilidade(data.checked);
    }

    mudaIdentificadorGRU(e){
        this.props.actions.updateIdentificadorGRU(e.target.value);
    }

    render() {
        return (
            <CardSimples titulo="Preferências" borderBottom form>
                
                <SelectField    
                    disabled={this.state.optionServicoBoleto.mensagem}
                    name='select-servico-boleto'
                    id='select-servico-boleto'
                    value={this.props.servicoBoleto} 
                    options={this.state.optionServicoBoleto} 
                    label='Serviço de Boleto' 
                    invalidMessage="Selecione uma opção"
                    onChange={this.setServicoBoleto} 
                    required 
                    className="m-0 width-100"/>
                {(this.state.optionServicoBoleto.mensagem) && (
                    <div className="mdl-textfield invalid touched width-100 p-t-0">
                        <div className={`field-message ${this.state.optionServicoBoleto.corMensagem}`}>{this.state.optionServicoBoleto.mensagem}</div>
                    </div>
                )}

                <CheckboxField width={4} rightLabel label='Disponibilizar GRU' onChange={this.setStatus} value={this.props.statusDisponibilidade}/>
                
                <RadioButtonGroup 
                    name="teste" inline
                    label="Selecione um valor" 
                    value={this.props.tipo}
                    options={this.radioOptions}  
                    onChange={this.mudaIdentificadorGRU}
                    width={6}/>
                 
            </CardSimples>
        );
    }
}

export default FormGRUPreferences;


// WEBPACK FOOTER //
// ./src/components/formbuilder/FormGRUPreferences.js